import { useMutation } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useUploadTrackmanParameterMainImageV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (file: File) => service.uploadMainImage(file),
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
